<template>
    <div class="information-wrapper content-wrapper">
        <el-collapse v-model="headerActiveName" accordion>
            <el-collapse-item name="headerInfo">
                <template slot="title">
                    <div class="header-title">
                        <span class="header-title-block"></span>
                        <span class="header-title-txt">基础信息
                            <el-tooltip class="item" effect="dark" content="点击跳转查看订单详情" placement="top">
                                <span class="header-title-jump" @click="openOrderCenter">{{  `( 客户订单号： ${formData.customerOrderNo} )` }}</span>
                            </el-tooltip>
                        </span>
                    </div>
                </template>
                <el-divider></el-divider>
                <el-form
                    label-position="left"
                    label-width="120px"
                    style="margin: 10px 0;"
                >
                    <el-row>
                        <el-col :span="6" v-for="(info, index) in orderList" :key="index">
                            <el-form-item :label="info.label">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="info.tooltip || info.value"
                                    placement="top-start"
                                >
                                    <div class="item-value" @dblclick="copyItem($event)">{{ info.value }}
                                    </div>
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-divider></el-divider>
                <el-collapse v-model="contentActiveName" accordion>
                    <el-collapse-item name="contentInfo">
                        <template slot="title">
                            <div class="content-title">
                                <span class="header-title-txt" style="font-size: 15px;">
                                    <strong>更多信息</strong>
                                </span>
                            </div>
                        </template>
                        <div class="card-container">
                            <el-card class="card-content">
                                <div slot="header" class="card-content-title">
                                    <span>分拨信息</span>
                                </div>
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="是否分拨：">
                                        <span @dblclick="copyItem($event)">{{ formData.distributionFlag || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="分拨段数：">
                                        <span @dblclick="copyItem($event)">{{ formateValue(formData.distributionNum) }}</span>
                                    </el-form-item>
                                    <el-form-item label="是否最后一次分拨：">
                                        <span @dblclick="copyItem($event)">{{ formData.distributionLastFlag || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="是否继续分拨：">
                                        <span @dblclick="copyItem($event)">{{ formData.continueDistribution || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="分拨仓库：">
                                        <el-tooltip class="item" effect="dark" :content="formData.distributionWhName || '--'" placement="top">
                                            <span @dblclick="copyItem($event)">{{ formData.distributionWhName || '--'}}</span>
                                        </el-tooltip>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                            <el-card class="card-content">
                                <div slot="header" class="card-content-title">
                                    <span>仓库信息</span>
                                </div>
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="发货仓库：">
                                        <el-tooltip class="item" effect="dark" :content="formData.orderWhName || '--'" placement="top">
                                            <span @dblclick="copyItem($event)">{{ formData.orderWhName || '--'}}</span>
                                        </el-tooltip>
                                    </el-form-item>
                                    <el-form-item label="分拨仓库：">
                                        <el-tooltip class="item" effect="dark" :content="formData.distributionWhName || '--'" placement="top">
                                            <span @dblclick="copyItem($event)">{{ formData.distributionWhName || '--'}}</span>
                                        </el-tooltip>
                                    </el-form-item>
                                    <el-form-item label="波次号：">
                                        <span @dblclick="copyItem($event)">{{ formData.waveId || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="WMS状态：">
                                        <span @dblclick="copyItem($event)">{{ formData.wmsStatus || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="库区名称：">
                                        <span @dblclick="copyItem($event)">{{ formData.zoneName || '--'}}</span>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                            <el-card class="card-content">
                                <div slot="header" class="card-content-title">
                                    <span>发运信息</span>
                                </div>
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="专业公司：">
                                        <span @dblclick="copyItem($event)">{{ formData.professionalCompany || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="发运类型：">
                                        <span @dblclick="copyItem($event)"> {{ formData.shippingType || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="是否基地：">
                                        <span @dblclick="copyItem($event)">{{ formData.orderDistinctionFlagName || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="运输类型：">
                                        <span @dblclick="copyItem($event)">{{ formData.transportType || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="线路名称：">
                                        <el-tooltip class="item" effect="dark" :content="formData.lineName || '--'" placement="top">
                                            <span @dblclick="copyItem($event)">{{ formData.lineName || '--'}}</span>
                                        </el-tooltip>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                            <el-card class="card-content">
                                <div slot="header" class="card-content-title">
                                    <span>下发承运商信息</span>
                                </div>
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="是否已下发承运商：">
                                        <span @dblclick="copyItem($event)"> {{ formData.carrierVisibleFlagName || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="下发人：">
                                        <span @dblclick="copyItem($event)">{{ formData.issueCarrierMip || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="下发时间：">
                                        <span @dblclick="copyItem($event)">{{ formData.carrierVisibleTime || '--'}}</span>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                            <el-card class="card-content">
                                <div slot="header" class="card-content-title">
                                    <span>服务信息</span>
                                </div>
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="服务类型：">
                                        <span @dblclick="copyItem($event)">{{ formData.serviceType || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="是否提供装卸服务：">
                                        <el-tooltip class="item" effect="dark" :content="formData.handlingCarrierName || '--'" placement="top">
                                            <span>
                                                {{ formData.handlingStatus || '--'}}
                                                (装卸供应商：<span @dblclick="copyItem($event)">{{ formData.handlingCarrierName || '--'}}</span>)
                                            </span>
                                        </el-tooltip>
                                    </el-form-item>
                                    <el-form-item label="高端服务：">
                                        <span @dblclick="copyItem($event)">{{ formData.orderTypeExt || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="项目分类：">
                                        <span @dblclick="copyItem($event)">{{ formData.projectClassify || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="是否上门取件：">
                                        <span @dblclick="copyItem($event)">{{ formData.dpFlag || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="VP客户标识：">
                                        <span @dblclick="copyItem($event)">{{ formData.vipFlag || '--'}}</span>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                            <el-card class="card-content">
                                <div slot="header" class="card-content-title">
                                    <span>零担信息</span>
                                </div>
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="是否下发零担平台：">
                                        <span @dblclick="copyItem($event)">{{ formData.isIssue || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="零担订单号：">
                                        <span @dblclick="copyItem($event)">{{ formData.lqId || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="零担运单号：">
                                        <span @dblclick="copyItem($event)">{{ formData.lclNo || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="平台单号：">
                                        <span @dblclick="copyItem($event)">{{ formData.platformOrderNo || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="平台车牌号：">
                                        <span @dblclick="copyItem($event)">{{ formData.lclVehicleCard || '--'}}</span>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                            <el-card class="card-content">
                                <div slot="header" class="card-content-title">
                                    <span>相关单号</span>
                                </div>
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="京东VC单号：">
                                        <span @dblclick="copyItem($event)">{{ formData.jdVcNo || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="上游集拼单号：">
                                        <span @dblclick="copyItem($event)">{{ formData.consolidationOrderNo || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="运单号：">
                                        <span @dblclick="copyItem($event)">{{ formData.waybillNo || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="计划单号：">
                                        <span @dblclick="copyItem($event)">{{ formData.planOrderNo || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="预约单号：">
                                        <span @dblclick="copyItem($event)">{{ formData.snAppointmentNo || '--'}}</span>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                            <el-card class="card-content">
                                <div slot="header" class="card-content-title">
                                    <span>事业部信息</span>
                                </div>
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="营销中心：">
                                        <span @dblclick="copyItem($event)">{{ formData.salesCenterName || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="销售来源平台：">
                                        <span @dblclick="copyItem($event)">{{ formData.orderSourcePlatform || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="事业部集拼单号：">
                                        <span @dblclick="copyItem($event)">{{ formData.assembleNo || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="事业部：">
                                        <span @dblclick="copyItem($event)">{{ formData.entityId || '--'}}</span>
                                    </el-form-item>
                                    <el-form-item label="厨热网点返修标识：">
                                        <span @dblclick="copyItem($event)">{{ formData.networkRepairName || '--'}}</span>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                            <el-card class="card-content full-width">
                                <div slot="header" class="card-content-title">
                                    <span>其他信息</span>
                                </div>
                                <el-form label-width="140px" label-position="left">
                                    <el-row :gutter="20">
                                        <el-col :span=6>
                                            <el-form-item label="线路里程（km）：">
                                                <span @dblclick="copyItem($event)">{{ formateValue(formData.mileage) }}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="买方类型：">
                                                <span @dblclick="copyItem($event)">{{ formData.sourceBuyerTenantType || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="是否需要扫码：">
                                                <span @dblclick="copyItem($event)">{{ formData.scanFlag || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="供方预约：">
                                                <span @dblclick="copyItem($event)">{{ formData.supplierReserveFlag || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="是否分仓标识：">
                                                <span @dblclick="copyItem($event)">{{ formData.isAllocateWhName || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="是否直控线路：">
                                                <span @dblclick="copyItem($event)">{{ formData.directControlFlag || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="源发车单号：">
                                                <span @dblclick="copyItem($event)">{{ formData.sourceDispatch || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="是否供应商转快递：">
                                                <span @dblclick="copyItem($event)">{{ formData.supplierKdFlag || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="后分仓标识：">
                                                <span @dblclick="copyItem($event)">{{ formData.orderDistinctionFlag || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="仓网融合平台：">
                                                <el-tooltip class="item" effect="dark" :content="formData.fuseSiteName || '--'" placement="top">
                                                    <span @dblclick="copyItem($event)">{{ formData.fuseSiteName || '--'}}</span>
                                                </el-tooltip>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="是否商超：">
                                                <span @dblclick="copyItem($event)">{{ formData.scPosFlag || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="转单类型：">
                                                <span @dblclick="copyItem($event)">{{ formData.transferType || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="班次编码：">
                                                <span @dblclick="copyItem($event)">{{ formData.shiftCode || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="服务产品名称：">
                                                <span @dblclick="copyItem($event)">{{ formData.productName || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="是否已扫码提货：">
                                                <span @dblclick="copyItem($event)">{{ formData.pickUpName || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="客户时效类型：">
                                                <span @dblclick="copyItem($event)">{{ formData.customerAgingType || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="移交单号：">
                                                <span @dblclick="copyItem($event)">{{ formData.transferNo || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="是否可见：">
                                                <span @dblclick="copyItem($event)">{{ formData.carrierVisibleFlagName || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="合同号：">
                                                <span @dblclick="copyItem($event)">{{ formData.contractNo || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="子单号：">
                                                <span @dblclick="copyItem($event)">{{ formData.orderNo || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="2C批量直配：">
                                                <span @dblclick="copyItem($event)">{{ formData.b2cZpFlagName || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span=6>
                                            <el-form-item label="运输里程(高德)(km)：">
                                                <span @dblclick="copyItem($event)">{{ formData.amapMileage || '--'}}</span>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </el-card>
                        </div>

                    </el-collapse-item>
                </el-collapse>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import { orderList } from '../config.js';
import { copyToClip } from '../util.js';
export default {
    name: 'OrderInformation',
    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data () {
        return {
            orderList,
            headerActiveName: 'headerInfo',
            contentActiveName: ''
        };
    },
    methods: {
        copyItem (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        },
        openOrderCenter () {
            this.$router.push({
                path: '/order-manage/order-detail',
                query: {
                    orderNo: this.formData.parentOrderNo
                }
            });
        },
        formateValue (value) {
            return (value === null || value === undefined || value === '') ? '--' : value;
        },
        /**
         * @description 渲染详情数据
         */
        handleRenderPage (info) {
            orderList.forEach(subItem => {
                if (subItem.key && subItem.key.length) {
                    subItem.value = info[subItem.key] || '--';
                } else if (typeof subItem.valueFn === 'function') {
                    subItem.value = subItem.valueFn(info);
                }
            });
        }
    },
    watch: {
        formData: {
            handler (newValue, oldValue) {
                this.handleRenderPage(newValue);
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
